namespace RioERP.Masters {
    export interface EmailTemplatesRow {
        Id?: number;
        Status?: Web.Enums.EmailEvent;
        EmailTemplate?: string;
        Variables?: string;
        VariableCodes?: string;
        IsActive?: boolean;
        Variable?: number[];
    }

    export namespace EmailTemplatesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'EmailTemplate';
        export const localTextPrefix = 'Masters.EmailTemplates';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Status = "Status",
            EmailTemplate = "EmailTemplate",
            Variables = "Variables",
            VariableCodes = "VariableCodes",
            IsActive = "IsActive",
            Variable = "Variable"
        }
    }
}
